import cx from 'classnames'
import React from 'react'
import { IProps } from './Interface'
import { palette } from 'config'
import { WordBankStatus } from 'types'
import { Chip, Typography } from '@material-ui/core'
import useStyles from './Styles'

const WordBank: React.FC<IProps> = ({ category, label, color, status, selected, className, onClick }) => {
  const classes = useStyles({ color, status, selected })

  return (
    <Chip
      className={cx(className, classes.wordBank, selected ? `${category}-selected` : category, {
        [classes.active]: status === WordBankStatus.Active && selected,
        [classes.pending]: selected && (status === WordBankStatus.Pending || status === WordBankStatus.Deleted)
      })}
      classes={{ root: classes.root }}
      label={
        <Typography id={`top-5-word-bank-${label.replace(/[^A-Z0-9]/gi, '-')}-label`} variant="body1">
          {label}
        </Typography>
      }
      onClick={onClick}
    />
  )
}

WordBank.defaultProps = {
  category: '',
  label: '',
  className: '',
  selected: false,
  color: palette.common.purple,
  status: WordBankStatus.Active,
  onClick: () => {}
}

export default React.memo(WordBank)
